import Character from "./Character";

export default function Group4(props) {


    return (

        <group

            {...props}

        >
            <Character
                {...props}
            />
        </group>

    )
}